import { DbDeleteCargo } from "../../../data/usecases/delete-cargo";
import { DeleteCargo } from "../../../domain/usecases/delete-cargo";
import { makeAuthorizeHttpClientDecorator } from "../decorators";
import { makeApiUrl } from "../http";

export const makeDbDeleteCargo = (): DeleteCargo =>
  new DbDeleteCargo(makeApiUrl("/cargo"), makeAuthorizeHttpClientDecorator());
